import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { FormGroup, Input, Label, Form } from "reactstrap";
import Card from "react-credit-cards";
import { withCookies } from "react-cookie";
import propTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "react-credit-cards/es/styles-compiled.css";
import ReCAPTCHA from "react-google-recaptcha";

import { Container, Campaign } from "./style";
import Submit from "../../components/Submit";
import SuperLoading from "../../components/SuperLoading";
import ContentBox from "../../components/ContentBox";
import { LinkExternal } from "../../assets/styles/components";

import { siteParams } from "../../config/site";
import { IS_APP } from "../../services/target";
import formatCreditCard from "../../services/creditCard";

import { Creators as CreditCardCreators } from "../../store/ducks/creditCard";
import { Creators as CampaignsCreators } from "../../store/ducks/campaigns";

class CreditCard extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showCard: false,
      number: "",
      name: "",
      expiry: "",
      cvc: "",
      focused: ""
    };
    this.recaptchaRef = React.createRef();
  }

  componentWillMount = () => {
    const { cookies } = this.props;

    const urlParams = new URLSearchParams(window.location.search);
    const hasCampaign = urlParams.has("campaign");
    if (hasCampaign) cookies.set("campaign", urlParams.get("campaign"));

    this.props.getCurrentCampaign(cookies.get("campaign"));
  };

  getCardData = e => {
    if (e.target.value.length > 2) {
      this.setState({ showCard: true && window.innerWidth - 11 > 349 });
    }
    e.target.value = formatCreditCard(e.target.name, e.target.value);
    this.setState({ [e.target.name]: e.target.value });
  };

  goSubscription = e => {
    e.preventDefault();
    this.recaptchaRef.current.execute();
  };

  handleInputFocus = ({ target }) => {
    this.setState({ focused: target.name });
  };

  getCaptchaValue = value => {
    if (!value) return;
    const { name, expiry, number, cvc } = this.state;

    this.props.subscription({
      holder_name: name,
      card_expiration: expiry,
      card_number: number,
      card_cvv: cvc,
      campaign_id: this.props.cookies.get("campaign"),
      reCode: value
    });
  };

  render() {
    const {
      loading,
      campaignName,
      displayPrice,
      displayDiscountedPrice,
      cycles,
      campaignLoading,
      cookies
    } = this.props;

    const placeholders = { name: "Nome no cartão" };
    const locale = { valid: "Validade" };

    const { showCard, name, expiry, number, cvc, focused } = this.state;

    return (
      <Container>
        <ContentBox>
          {!campaignLoading && (
            <Campaign>
              <FontAwesomeIcon icon="trophy" />
              {cycles !== null && (
                <span>
                  Você está assinando o plano <strong>{campaignName}</strong>{" "}
                  por <strong>{displayDiscountedPrice}</strong> durante{" "}
                  <strong>{cycles} meses</strong>, após{" "}
                  <strong>{displayPrice}</strong>
                </span>
              )}
              {cycles === null && (
                <span>
                  Você está assinando o plano <strong>{campaignName}</strong>{" "}
                  por <strong>{displayPrice}</strong>
                </span>
              )}
            </Campaign>
          )}
          <div id="card-wrapper" style={{ display: showCard && "block" }}>
            <Card
              number={number}
              name={name}
              expiry={expiry}
              cvc={cvc}
              focused={focused}
              placeholders={placeholders}
              callback={this.handleCallback}
              locale={locale}
            />
          </div>
          <Form onSubmit={this.goSubscription} ref={this.form}>
            <FormGroup>
              <Label for="number">Número do cartão</Label>
              <Input
                placeholder="Número do Cartão"
                type="tel"
                name="number"
                pattern="[\d| ]{16,22}"
                onChange={this.getCardData}
                onFocus={this.handleInputFocus}
                value={number}
                required
              />
            </FormGroup>
            <FormGroup>
              <Label for="Name">Nome impresso no cartão</Label>
              <Input
                placeholder="Nome no cartão"
                type="text"
                name="name"
                onChange={this.getCardData}
                onFocus={this.handleInputFocus}
                required
              />
            </FormGroup>

            <div className="form-row">
              <div className="form-group col-md-6">
                <Label for="expiry">Data de expiração</Label>
                <Input
                  placeholder="MM/AAAA"
                  pattern="\d\d/\d\d\d\d"
                  type="tel"
                  name="expiry"
                  onChange={this.getCardData}
                  onFocus={this.handleInputFocus}
                  value={expiry}
                  required
                />
              </div>
              <div className="form-group col-md-6">
                <Label htmlFor="cvc">Código CVC</Label>
                <Input
                  placeholder="CVC"
                  type="tel"
                  name="cvc"
                  pattern="\d{3,4}"
                  onChange={this.getCardData}
                  onFocus={this.handleInputFocus}
                  required
                />
              </div>
            </div>
            <ReCAPTCHA
              ref={this.recaptchaRef}
              size="invisible"
              sitekey="6LfImM0UAAAAAJtCRmE_nO3wNyp8GQ9O2UXPNNs_"
              onChange={this.getCaptchaValue}
            />
            <Submit loading={loading} name="Finalizar" className="btn-block" />
          </Form>
          {!IS_APP && !cookies.get("campaign") && (
            <LinkExternal href={siteParams.download.url}>
              Continuar sem assinatura
            </LinkExternal>
          )}
          <SuperLoading
            show={loading}
            message="Aguarde, estamos processando sua assinatura"
          />
        </ContentBox>
      </Container>
    );
  }
}

CreditCard.propTypes = {
  subscription: propTypes.func.isRequired,
  loading: propTypes.bool.isRequired,
  campaignLoading: propTypes.bool.isRequired,
  getCurrentCampaign: propTypes.func.isRequired,
  displayPrice: propTypes.string.isRequired,
  displayDiscountedPrice: propTypes.string.isRequired,
  cycles: propTypes.number.isRequired,
  campaignName: propTypes.string.isRequired
};

const mapStateToProps = state => ({
  loading: state.creditCard.loading,
  displayPrice: state.campaigns.display_cost,
  displayDiscountedPrice: state.campaigns.discounted_price,
  cycles: state.campaigns.cycles,
  campaignName: state.campaigns.name,
  campaignLoading: state.campaigns.loading
});

const mapDispatchToProps = d =>
  bindActionCreators({ ...CreditCardCreators, ...CampaignsCreators }, d);

export default withCookies(
  connect(mapStateToProps, mapDispatchToProps)(CreditCard)
);



// WEBPACK FOOTER //
// ./src/pages/creditCard/index.js